// Ariza statuslari va bosqichlari — backend enum'lariga mos yorliqlar.
// ----------------------------------------------------------------------

export const STATUS_LABELS = {
  NEW: 'Yangi',
  CONTACTED: 'Gaplashildi',
  ENROLLED: "Ro'yxatga olindi",
  REJECTED: 'Rad etdi',
};

/** MUI Chip/Label ranglari. */
export const STATUS_COLORS = {
  NEW: 'info',
  CONTACTED: 'warning',
  ENROLLED: 'success',
  REJECTED: 'error',
};

export const STATUS_ORDER = ['NEW', 'CONTACTED', 'ENROLLED', 'REJECTED'];

/** Yarim qolgan arizalarda o'quvchi qaysi savolda to'xtaganini ko'rsatadi. */
export const STEP_LABELS = {
  FULL_NAME: 'Ism familiya kutilmoqda',
  PHONE: 'Telefon kutilmoqda',
  SUBJECTS: 'Fan tanlanmoqda',
  GRADE: 'Sinf tanlanmoqda',
  NOTE: 'Izoh kutilmoqda',
  DONE: 'Yakunlangan',
};

/** +998901234567 → +998 90 123 45 67 */
export const formatPhone = (phone) => {
  const d = String(phone ?? '').replace(/\D/g, '');
  if (d.length !== 12) return phone || '—';
  return `+${d.slice(0, 3)} ${d.slice(3, 5)} ${d.slice(5, 8)} ${d.slice(8, 10)} ${d.slice(10)}`;
};

export const formatDate = (value, withTime = false) => {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString('uz-UZ', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}),
    });
  } catch {
    return '—';
  }
};
